import { Action } from '@ngrx/store';

export enum BriefActionTypes {
  Load = '[API] Load briefs',
  LoadSuccess = '[API] Load briefs success',
  LoadFail = '[API] Load briefs fail',
  
  LoadInfoModal = '[API] Load indo modal',
  LoadInfoModalSuccess = '[API] Load indo modal success',
  LoadInfoModalFail = '[API] Load indo modal fail',

  CreateBrief = '[API] Create brief',
  CreateBriefSuccess = '[API] Create Brief success',
  CreateBriefFail = '[API] Create Brief fail',

  UpdateBrief = '[API] Update brief',
  UpdateBriefSuccess = '[API] Update Brief success',
  UpdateBriefFail = '[API] Update Brief fail',

  ExportBrief = '[API] Export brief',
  ExportBriefSuccess = '[API] Export Brief success',
  ExportBriefFail = '[API] Export Brief fail',
  // -----------------------
  GetLink = '[API] Get Link',
  // GetLinkSuccess = '[API] Get Link success',
  GetLinkFail = '[API] Get Link fail',

  UploadFile = '[API] Upload File',
  UploadFileSuccess = '[API] Upload File success',
  UploadFileFail = '[API] Upload File fail',

  ChangeStatus = '[API] Change Status brief',
  ChangeStatusSuccess = '[API] Change status brief success',
  ChangeStatusFail = '[API] Change status brief fail',

  ExportInitialBrief = '[API] Export initial brief',
  ExportInitialBriefSuccess = '[API] Export initial brief success',
  ExportInitialBriefFail = '[API] Export initial brief fail',

  DownloadBriefFinal = '[API] Download brief final',

  DownloadBriefPM = '[API] Download brief PM',
  DownloadBriefPMSuccess = '[API] Download brief PM success',
  DownloadBriefPMFail = '[API] Download brief PM fail',
}

export class Load implements Action {
  readonly type = BriefActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = BriefActionTypes.LoadSuccess;
  constructor(public data: any) {}
}

export class LoadFail implements Action {
  readonly type = BriefActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadInfoModal implements Action {
  readonly type = BriefActionTypes.LoadInfoModal;
  constructor() {}
}

export class LoadInfoModalSuccess implements Action {
  readonly type = BriefActionTypes.LoadInfoModalSuccess;
  constructor(public data: any) {}
}

export class LoadInfoModalFail implements Action {
  readonly type = BriefActionTypes.LoadInfoModalFail;
  constructor(public error: any) {}
}

export class CreateBrief implements Action {
  readonly type = BriefActionTypes.CreateBrief;
  constructor(public data: any, public file: any) {}
}

export class CreateBriefSuccess implements Action {
  readonly type = BriefActionTypes.CreateBriefSuccess;
  constructor(public data: any) {}
}

export class CreateBriefFail implements Action {
  readonly type = BriefActionTypes.CreateBriefFail;
  constructor(public error: any) {}
}

export class UpdateBrief implements Action {
  readonly type = BriefActionTypes.UpdateBrief;
  constructor(public id: any, public data: any) {}
}

export class UpdateBriefSuccess implements Action {
  readonly type = BriefActionTypes.UpdateBriefSuccess;
  constructor(public data: any) {}
}

export class UpdateBriefFail implements Action {
  readonly type = BriefActionTypes.UpdateBriefFail;
  constructor(public error: any) {}
}

export class ExportBrief implements Action {
  readonly type = BriefActionTypes.ExportBrief;
  constructor(public id: any, public fileName: any) {}
}

export class ExportBriefSuccess implements Action {
  readonly type = BriefActionTypes.ExportBriefSuccess;
  constructor() {}
}

export class ExportBriefFail implements Action {
  readonly type = BriefActionTypes.ExportBriefFail;
  constructor(public error: any) {}
}

// ---------------------------------------------
export class GetLink implements Action {
  readonly type = BriefActionTypes.GetLink;
  constructor(
    public owner: any,
    public file: any,
    public featured: boolean,
    public data: any,
    public isConfirmation: boolean
  ) {}
}

export class GetLinkFail implements Action {
  readonly type = BriefActionTypes.GetLinkFail;
  constructor(public error: any) {}
}

export class UploadFile implements Action {
  readonly type = BriefActionTypes.UploadFile;
  constructor(
    public link: string,
    public file: any,
    public data: any,
    public isConfirmation: boolean
  ) {}
}

export class UploadFileSuccess implements Action {
  readonly type = BriefActionTypes.UploadFileSuccess;
  constructor() {}
}

export class UploadFileFail implements Action {
  readonly type = BriefActionTypes.UploadFileFail;
  constructor(public error: any) {}
}

export class ChangeStatus implements Action {
  readonly type = BriefActionTypes.ChangeStatus;
  constructor(public data: any) {}
}

export class ChangeStatusSuccess implements Action {
  readonly type = BriefActionTypes.ChangeStatusSuccess;
  constructor(public data: any) {}
}

export class ChangeStatusFail implements Action {
  readonly type = BriefActionTypes.ChangeStatusFail;
  constructor(public error: any) {}
}

export class ExportInitialBrief implements Action {
  readonly type = BriefActionTypes.ExportInitialBrief;
  constructor() {}
}

export class ExportInitialBriefSuccess implements Action {
  readonly type = BriefActionTypes.ExportInitialBriefSuccess;
  constructor() {}
}

export class ExportInitialBriefFail implements Action {
  readonly type = BriefActionTypes.ExportInitialBriefFail;
  constructor(public error: any) {}
}

export class DownloadBriefPM implements Action {
  readonly type = BriefActionTypes.DownloadBriefPM;
  constructor(public id: any, public fileName: string) {}
}
export class DownloadBriefFinal implements Action {
  readonly type = BriefActionTypes.DownloadBriefFinal;
  constructor(public id: any, public fileName: string) {}
}

export class DownloadBriefPMSuccess implements Action {
  readonly type = BriefActionTypes.DownloadBriefPMSuccess;
  constructor() {}
}

export class DownloadBriefPMFail implements Action {
  readonly type = BriefActionTypes.DownloadBriefPMFail;
  constructor(public error: any) {}
}

export type BriefActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadInfoModal
  | LoadInfoModalSuccess
  | LoadInfoModalFail
  | CreateBrief
  | CreateBriefSuccess
  | CreateBriefFail
  | UpdateBrief
  | UpdateBriefSuccess
  | UpdateBriefFail
  | ExportBrief
  | ExportBriefSuccess
  | ExportBriefFail
  | GetLink
  | GetLinkFail
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | ChangeStatus
  | ChangeStatusSuccess
  | ChangeStatusFail
  | ExportInitialBrief
  | ExportInitialBriefSuccess
  | ExportInitialBriefFail
  | DownloadBriefPM
  | DownloadBriefPMSuccess
  | DownloadBriefPMFail
  | DownloadBriefFinal;
